import React from 'react';
import { Link } from '@chakra-ui/react';
import { Link as GatsbyLink } from 'gatsby';

const LinkType = ({ children, to, activeClassName, partiallyActive, ...other }) => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(to);

  // Use Gatsby Link for internal links, and Chakra Link for others
  if (internal) {
    return (
      <Link
        to={to}
        as={GatsbyLink}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        _focus={{ boxShadow: 'none' }}
        {...other}
      >
        {children}
      </Link>
    );
  }
  return (
    <Link href={to} _focus={{ boxShadow: 'none' }} {...other}>
      {children}
    </Link>
  );
};

export default {
  component: LinkType,
  children: ({ content }) => ({
    children: content,
  }),
};
